module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "ChTitle",
    attrs: {
      "id": "ch17"
    }
  }, [_c('a', {
    attrs: {
      "id": "ch17a"
    }
  }), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#rch17"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("MR. BASEBALL")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_c('i', [_vm._v("After a lackluster baseball career, Bob Uecker became an actor, sports broadcaster, and TV personality. And he’s funny about it all, too.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("“I helped the Cardinals win the pennant. I came down with hepatitis.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“I signed with the Milwaukee Braves for $3,000. That bothered my dad because he didn’t have that kind of dough, but he eventually scraped it up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“When I came up to bat with three men on and two outs in the ninth, I looked in the other team’s dugout, and they were already in street clothes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“I go to a lot of Old Timers games, and I haven’t lost a thing. I sit in the bullpen and let people throw things at me. Just like old times.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“I led the league in ‘Go get ’em next time.’”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“If a guy hits .300 every year, what does he have to look forward to? I always tried to stay around .190, with three or four RBI. And I tried to get them all in September. That way I always had something to talk about during the winter.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“I knew when my career was over. In 1965 my baseball card came out with no picture.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“The biggest thrill a ballplayer can have is when your son takes after you. That happened when my Bobby was in his championship Little League game. Struck out three times. Gosh, I was proud.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“When I looked to the third-base coach for a sign, he turned his back on me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“I had slumps that lasted into the winter.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“The highlight of my career? In ’67 with St. Louis, I walked with the bases loaded to drive in the winning run in an intersquad game in spring training.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“I won the Comeback of the Year Award five years in a row.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“I set records that will never be equaled. In fact, I hope 90 percent of them don’t even get printed.”")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center7"
  }, [_c('span', [_c('b', [_vm._v("Seeing the color red can make your heart beat faster.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c22805c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter017.vue
// module id = 129
// module chunks = 0